
import { BusinessFormData } from '../types';
import { formatDate } from '@/utils/dateUtils';

interface UseFormHandlersProps {
  formData: BusinessFormData;
  setFormData: React.Dispatch<React.SetStateAction<BusinessFormData>>;
  initialFormData: BusinessFormData;
  formChanged: boolean;
  setDisplayNameManuallyEdited: React.Dispatch<React.SetStateAction<boolean>>;
  setCalendarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
}

export const useFormHandlers = ({
  formData,
  setFormData,
  initialFormData,
  formChanged,
  setDisplayNameManuallyEdited,
  setCalendarOpen,
  setDate
}: UseFormHandlersProps) => {
  // Handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    // Mark display name as manually edited if changed directly
    if (name === 'displayName' && value !== formData.name) {
      setDisplayNameManuallyEdited(true);
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  // Handle select changes
  const handleSelectChange = (value: string, field: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
  // Handle date selection
  const handleDateSelect = (selectedDate: Date | undefined) => {
    setDate(selectedDate);
    setCalendarOpen(false);
    
    if (selectedDate) {
      const formattedDate = formatDate(selectedDate);
      setFormData(prev => ({
        ...prev,
        openingDate: formattedDate
      }));
    }
  };
  
  // Cancel and reset form
  const handleCancel = () => {
    // Ask user to confirm if there are unsaved changes
    if (formChanged) {
      const confirmed = window.confirm("You have unsaved changes. Are you sure you want to cancel?");
      if (!confirmed) {
        return false;
      }
    }
    
    setFormData(initialFormData);
    return true;
  };

  return {
    handleInputChange,
    handleSelectChange,
    handleDateSelect,
    handleCancel
  };
};
